import { invoiceStatusConfig } from 'entities';

import { Card } from 'components/Blocks';

import { ReadyToInvoice } from './ReadyToInvoice';
import { ReadyToSendToAccountant } from './ReadyToSendToAccountant';
import { SentToAccountant } from './SentToAccountant';
import { Invoiced } from './Invoiced';
import { Paid } from './Paid';
import { Canceled } from './Canceled';

const customComponents: Record<string, typeof ReadyToInvoice> = {
  'pre-creation': ReadyToInvoice,

  [invoiceStatusConfig.readyToSendToAccountant.queryParam]: ReadyToSendToAccountant,

  [invoiceStatusConfig.sentToAccountant.queryParam]: SentToAccountant,

  [invoiceStatusConfig.invoiced.queryParam]: Invoiced,

  [invoiceStatusConfig.paid.queryParam]: Paid,

  [invoiceStatusConfig.canceled.queryParam]: Canceled,
};

export function InvoiceStatuses({ tab }: { tab: string }) {
  const Component = customComponents[tab];

  return <Card>{Component && <Component />}</Card>;
}
